import { useTranslation } from "react-i18next";
import Container from "../components/common/Container";
import Title from "../components/common/Title";
import Content from "../components/common/Content";
import Navigation from "../components/ui/Navigation";
import BrainVisual from "../components/ui/BrainVisual";
import styled from "styled-components";
import { Route, Switch, useParams } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import GameSelector from "../components/ui/GameSelector";
import { useEffect, useState } from "react";
import { navigationHistory } from "../routes";
import BulletButton from "../components/ui/BulletButton";
import Button from "../components/ui/Button";
import { ReactComponent as ArrowLeft } from "../assets/icons/arrow-left.svg";
import DifficultySelector from "../components/ui/DifficultySelector";
import Divider from "../components/ui/Divider";
import TrainingDetail from "../components/ui/TrainingDetail";

const Introduction = styled.div`
  border-top: 1px solid #ddd;
  padding: 15px;
`;

export default () => {
  const { t } = useTranslation("games");
  const { id: gameId }: any = useParams();

  const [level, setLevel] = useState(1);

  const game = useSelector((state: RootState) =>
    state.navigation.items.find(({ name }) => name === gameId)
  );


  useEffect(() => setLevel(1), [game]);

  return (
    <>
      <Content>
        <GameSelector current={game} />
        <Button
          onClick={() => navigationHistory.push("/games")}
          suffix={t("back")}
        >
          <ArrowLeft />
        </Button>
      </Content>
      <Container>
        {game ? (
          <game.component
            onSetLevel={(level: any) => setLevel(level)}
            game={game}
          />
        ) : (
          <></>
        )}
      </Container>
      <Divider />
      <Content>
        {game?.name === "catchtheball" ? (
          level != 3 ? (
            <p>
              Klicken Sie auf <strong>»Start«</strong>. Greifen Sie dann die
              Korb-Markierung mit der Maus. Schieben Sie den Korb mit gedrückter{" "}
              <strong>linker Maustaste</strong> auf der Schiene hin und her, um
              die Bälle zu fangen.
            </p>
          ) : (
            <p>
              Klicken Sie auf <strong>»Start«</strong>. Greifen Sie dann die
              Korb-Markierung mit der Maus. Schieben Sie den Korb mit gedrückter{" "}
              <strong>linker Maustaste</strong> auf der Schiene hin und her, um
              die Bälle zu fangen. <br />
              <strong>Achtung:</strong> Der Korb bewegt sich gegenläufig, das
              heißt nach rechts, wenn Sie die Maus nach links schieben und
              umgekehrt!
            </p>
          )
        ) : game?.name === "remember" ? (
          level === 1 ? (
            <p>
              Nachdem Sie auf <strong>»Start«</strong> geklickt haben, sehen Sie{" "}
              <strong>4</strong> Symbole im Abstand von jeweils{" "}
              <strong>1 Sekunde</strong>. Klicken Sie sofort anschließend auf{" "}
              <strong>»Abfrage starten«</strong>. <strong>Markieren</strong> Sie
              dann zügig die Symbole in der Auswahl. Ihre Entscheidungen werden
              nur dann als richtig angezeigt, wenn Sie die bei der Präsentation
              vorgegebene <strong>Reihenfolge</strong> exakt einhalten. Für
              diese Aufgabe steht Ihnen nur begrenzt Zeit zur Verfügung. Sie
              müssen sich schnell entscheiden.
              <br />
              Führen Sie die Übung nicht zu häufig nacheinander durch.{" "}
              <strong>2-3 Durchgänge</strong> genügen meist. Andernfalls fällt
              das Löschen der vorherigen Informationen schwer.
            </p>
          ) : level === 2 ? (
            <p>
              Nachdem Sie auf <strong>»Start«</strong> geklickt haben, sehen Sie{" "}
              <strong>5</strong> Symbole im Abstand von jeweils{" "}
              <strong>1 Sekunde</strong>. Klicken Sie sofort anschließend auf{" "}
              <strong>»Abfrage starten«</strong>. <strong>Markieren</strong> Sie
              dann zügig die Symbole in der Auswahl. Ihre Entscheidungen werden
              nur dann als richtig angezeigt, wenn Sie die bei der Präsentation
              vorgegebene <strong>Reihenfolge</strong> exakt einhalten. Für
              diese Aufgabe steht Ihnen nur begrenzt Zeit zur Verfügung. Sie
              müssen sich schnell entscheiden.
              <br />
              Führen Sie die Übung nicht zu häufig nacheinander durch.{" "}
              <strong>2-3 Durchgänge</strong> genügen meist. Andernfalls fällt
              das Löschen der vorherigen Informationen schwer.
            </p>
          ) : level === 3 ? (
            <p>
              Nachdem Sie auf <strong>»Start«</strong> geklickt haben, sehen Sie{" "}
              <strong>6</strong> Symbole im Abstand von jeweils{" "}
              <strong>1 Sekunde</strong>. Klicken Sie sofort anschließend auf{" "}
              <strong>»Abfrage starten«</strong>. <strong>Markieren</strong> Sie
              dann zügig die Symbole in der Auswahl. Ihre Entscheidungen werden
              nur dann als richtig angezeigt, wenn Sie die bei der Präsentation
              vorgegebene <strong>Reihenfolge</strong> exakt einhalten. Für
              diese Aufgabe steht Ihnen nur begrenzt Zeit zur Verfügung. Sie
              müssen sich schnell entscheiden.
              <br />
              Führen Sie die Übung nicht zu häufig nacheinander durch.{" "}
              <strong>2-3 Durchgänge</strong> genügen meist. Andernfalls fällt
              das Löschen der vorherigen Informationen schwer.
            </p>
          ) : (
            <p>
              Nachdem Sie auf <strong>»Start«</strong> geklickt haben, sehen Sie{" "}
              <strong>7</strong> Symbole im Abstand von jeweils{" "}
              <strong>1 Sekunde</strong>. Klicken Sie sofort anschließend auf{" "}
              <strong>»Abfrage starten«</strong>. <strong>Markieren</strong> Sie
              dann zügig die Symbole in der Auswahl. Ihre Entscheidungen werden
              nur dann als richtig angezeigt, wenn Sie die bei der Präsentation
              vorgegebene <strong>Reihenfolge</strong> exakt einhalten. Für
              diese Aufgabe steht Ihnen nur begrenzt Zeit zur Verfügung. Sie
              müssen sich schnell entscheiden.
              <br />
              Führen Sie die Übung nicht zu häufig nacheinander durch.{" "}
              <strong>2-3 Durchgänge</strong> genügen meist. Andernfalls fällt
              das Löschen der vorherigen Informationen schwer.
            </p>
          )
        ) : game?.name === "fingerlauf" ? (
          level === 1 ? (
            <p>
              Legen Sie beide Hände flach auf den Tisch{" "}
              <strong>mit den Handrücken nach oben</strong>. Belegen Sie in
              Gedanken Ihre Finger mit den Buchstaben, die Sie auf den hier
              abgebildeten Händen sehen. »Schreiben« Sie nun das angezeigte
              Wort, indem Sie mögllchst zügig nacheinander die entsprechenden
              Finger kurz anheben und wieder ablegen. Sie dürfen die Angaben auf
              dem Bildschirm dabei immer betrachten. Beim Wort »SPORT« heben Sie
              also schnell hintereinander die folgenden Finger: rechter kleiner
              Finger, rechter Mittelfinger, linker Daumen, linker Ringfinger,
              linker Mittelfinger. <br /> Klicken Sie anschließend auf den Knopf{" "}
              <strong>»Neuer Begriff«</strong> und verfahren Sie genauso.
            </p>
          ) : level === 2 ? (
            <p>
              Legen Sie beide Hände flach auf den Tisch{" "}
              <strong>mit den Handflächen nach oben</strong>. Belegen Sie in
              Gedanken Ihre Finger mit den Buchstaben, die Sie auf den hier
              abgebildeten Händen sehen. »Schreiben« Sie nun die angezeigten
              Begriffe, durch kurzes Anheben der Finger. Sie dürfen die Angaben
              auf dem Bildschirm dabei immer betrachten. Die Zuordnung der
              Buchstaben zu den Fingern bleibt wie auf der Abbildung zu sehen.
              Sie müssen also in Gedanken die Finger jeweils neu positionieren.{" "}
              <br /> Klicken Sie anschließend auf den Knopf{" "}
              <strong>»Neuer Begriff«</strong> und verfahren Sie genauso.
            </p>
          ) : (
            <p>
              Legen Sie beide Hände <strong>mit überkreuzten Armen</strong>{" "}
              flach auf den Tisch mit den Handrücken nach oben. Ihre linke Hand
              liegt auf der rechten Seite, die rechte Hand auf der linken.
              Belegen Sie in Gedanken Ihre Finger mit den Buchstaben, die Sie
              auf den hier abgebildeten Händen sehen. »Schreiben« Sie nun die
              angezeigten Begriffe, durch kurzes Anheben der Finger. Sie dürfen
              die Angaben auf dem Bildschirm dabei immer betrachten. Die
              Zuordnung der Buchstaben zu den Fingern bleibt wie auf der
              Abbildung zu sehen. Sie müssen also in Gedanken die Finger jeweils
              neu positionieren. <br /> Klicken Sie anschließend auf den Knopf{" "}
              <strong>»Neuer Begriff«</strong> und verfahren Sie genauso.
            </p>
          )
        ) : game?.name === "numberjungle" ? (
          level === 1 ? (
            <p>
              Suchen Sie die Zahlen von 1 bis 50{" "}
              <strong>in aufsteigender Reihenfolge</strong> und klicken Sie sie
              an, das heißt zuerst die 1, dann die 2 usw. bis zur 50.
              <br />
              Die richtig angeklickten Zahlen verschwinden. Gehen Sie möglichst
              zügig vor!
            </p>
          ) : level === 2 ? (
            <p>
              Suchen Sie die Zahlen von 50 bis 1{" "}
              <strong>in absteigender Reihenfolge</strong> und klicken Sie sie
              an, das heißt zuerst die 50, dann die 49 usw. bis zur 1. <br />
              Die bereits richtig angeklickten Zahlen bleiben unverändert
              stehen. Gehen Sie möglichst zügig vor!
            </p>
          ) : (
            <p>
              Suchen und klicken Sie nacheinander die 50 Zahlen an.{" "}
              <strong>Die Reihenfolge</strong>, in der Sie suchen sollen,{" "}
              <strong>wird Ihnen angezeigt</strong>. <br />
              Sobald Sie eine Zahl angeklickt haben, erscheint auf dem
              Bildschirm die Information, welche Zahl Sie als nächste suchen und
              anklicken sollen. Bereits angeklickte Zahlen bleiben unverändert
              erhalten.
            </p>
          )
        ) : game?.name === "bleistiftakrobatik" ? (
          level === 1 ? (
            <p>
              Legen Sie einen Stift vor sich auf den Tisch. Lassen Sie diesen im
              Uhrzeigersinn kreisen unter Einsatz von Daumen, Zeigefinger und
              Mittelfinger einer Hand. Dabei "steigen" quasi Ihre Finger in
              schneller Folge nacheinander über den Stift und drehen ihn in die
              Bewegungsrichtung. <br />
              Vollziehen Sie Bewegung so schnell wie möglich! Probieren Sie’s
              auch entgegen dem Uhrzeigersinn und mit der anderen Hand!
            </p>
          ) : level === 2 ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p>
                Nehmen Sie einen Stift in eine Hand und drehen Sie ihn unter
                Einsatz von Daumen, Zeigefinger und Mittelfinger um seine
                Längsachse. Ändern Sie zwischendurch die Bewegungsrichtung mal
                zum Körper hin, mal vom Körper weg. Drehen Sie so schnell Sie
                können! Versuchen Sie es nacheinander mit beiden Händen.{" "}
                <strong>Variationen:</strong>
                <ul style={{marginTop: "0px"}}>
                  <li >
                    Versuchen Sie die Übung mit einem Bleistift in jeder Hand.
                  </li>
                  <li>
                    Benutzen Sie zum Drehen des Stiftes nur Zeige-, Mittel- und
                    Ringfinger.
                  </li>
                  <li>Der Daumen sollte möglichst nicht helfen.</li>
                  <li>
                    Lassen Sie den Stift beim Drehen um seine Längsachse wie im
                    Slalom durch Ihre Finger laufen. Der Stift wird quasi durch
                    die Finger »gewebt«.
                  </li>
                </ul>
              </p>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p>
                Halten Sie einen Stift mit einer Hand senkrecht wie ein Lot und
                halten Sie gleichzeitig die andere Hand ca. 20 bis 30 cm
                darunter auffangbereit. Lassen Sie den Stift senkrecht fallen
                und fangen Sie ihn mit der unteren Hand auf. Wechseln Sie die
                Fanghand - mal fängt die rechte, mal die linke Hand. <br />
                <strong>Variationen:</strong>
                <br />
                Gehen Sie genauso vor wie oben, aber die Fanghand fängt nur mit
                zwei Fingern, also Daumen und Zeigefinger, Daumen und
                Mittelfinger, Daumen und Ringfinger oder Daumen und kleinem
                Finger.
              </p>
            </div>
          )
        ) : game?.name === "crossword" ? (
          level === 1 ? (
            <p>
              Finden Sie im Raster das Wort <strong>SPORT</strong>, indem Sie
              aneinander grenzende Kästchen miteinander verbinden. Die gedachten
              Linien können gerade, schräg oder im Zickzack waagerecht oder
              senkrecht, aufwärts oder abwärts, links oder rechts beginnend
              verlaufen, das heißt in alle Leserichtungen. Es kommt nicht darauf
              an, ob die Buchstaben klein oder groß geschrieben sind - Sport,
              SPORT, sPorT, SPOrt, spORT usw. alles zählt als »Sport«.
              <br />
              Markieren Sie die gefundenen Wörter durch Anklicken der einzelnen
              Buchstabenfelder. Die gefundenen Wörter werden dann farbig
              hervorgehoben.
            </p>
          ) : (
            <p>
              Finden Sie im Raster das Wort <strong>SPORT</strong>, indem Sie
              aneinander grenzende Kästchen miteinander verbinden. Die gedachten
              Linien können gerade, schräg oder im Zickzack waagerecht oder
              senkrecht, aufwärts oder abwärts, links oder rechts beginnend
              verlaufen, das heißt in alle Leserichtungen. Es kommt nicht darauf
              an, ob die Buchstaben klein oder groß geschrieben sind - Sport,
              SPORT, sPorT, SPOrt, spORT usw. alles zählt als »Sport«.
              <br />
              Markieren Sie die gefundenen Wörter durch Anklicken der einzelnen
              Buchstabenfelder. Die gefundenen Wörter werden dann kurz farbig
              hervorgehoben. Die Markierung verschwindet anschließend wieder.
            </p>
          )
        ) : game?.name === "scramble" ? (
          <p>
            Ordnen Sie die Buchstaben neu. Bei richtiger Zusammenstellung ergibt
            sich ein sinnvolles Wort. Ziehen Sie die Buchstaben zu diesem Zweck
            mit der Maus in das entsprechende Feld für das Lösungswort. <br />
            Kleiner Tipp: Alle Begriffe drehen sich um den Sport. Beachten Sie:
            Umlaute wurden aufgelöst, das heißt Ä = AE,Ö = OE,Ü = UE,ß = SS.{" "}
            <br />
            Überlegen Sie nicht zu lange. Dabei drehen sich nur die Gedanken im
            Kreis. Statt zu lange zu Grübeln, sollten Sie lieber mit einem Klick
            auf <strong>»Nächster Begriff«</strong> zur nächsten Aufgabe weiter
            gehen.
          </p>
        ) : game?.name === "fingerskilled" ? (
          level === 1 ? (
            <p>
              Ahmen Sie die jeweils angezeigte Gebärde nach. Beginnen Sie mit
              der rechten Hand wie in der Abbildung. Übertragen Sie die
              Darstellung dann gegengleich auf die linke Hand.
              <br /> Haben Sie die Bewegung nachvollzogen, klicken sie auf{" "}
              <strong>»Weiter«</strong>, um zur nächsten Gebärde zu gelangen.
            </p>
          ) : level === 2 ? (
            <p>
              Für wenige Sekunden wird Ihnen eine Gebärde angezeigt. Versuchen
              Sie, sich diese zu merken. Vollziehen Sie sie erst dann nach, wenn
              sie vom Bildschirm verschwunden ist und halten Sie die Hand in der
              entsprechenden Position.
              <br />
              Nun klicken Sie auf <strong>»Kontrolle«</strong>, damit das Motiv
              noch einmal angezeigt wird und Sie Ihre Gebärde überprüfen können.
              <br />
              Mit einem Klick auf <strong>»Weiter«</strong> geht's zur nächsten
              Gebärde.
            </p>
          ) : (
            <p>
              Es wird Ihnen eine Folge von zwei oder mehr Gebärden gezeigt. Die
              Anzahl zwischen zwei und fünf Gebärden nacheinander können Sie
              frei wählen. Dabei ist jede einzelne Gebärde nur wenige Sekunden
              lang eingeblendet. Versuchen Sie, sich die Folge zu merken.
              <br />
              Vollziehen Sie sie erst dann nach, wenn das letzte Motiv vom
              Bildschirm verschwunden ist. Nun klicken Sie auf{" "}
              <strong>»Kontrolle«</strong>, damit die Motive noch einmal
              angezeigt werden und Sie Ihre Gebärde überprüfen können.
              <br />
              Mit einem Klick auf <strong>»Weiter«</strong> geht's zur nächsten
              Gebärdenfolge.
            </p>
          )
        ) : game?.name === "armsup" ? (
          level === 1 ? (
            <p>
              Es werden nach und nach Spielkarten gezeigt, auf denen
              unterschiedliche Informationen enthalten sind, verteilt auf fünf
              Felder. Konzentrieren Sie sich ausschließlich auf die Pfeile.
              Bringen Sie, sobald eine Karte erscheint, möglichst schnell Ihre
              beiden Arme gestreckt{" "}
              <strong>in die vom Pfeil angezeigte Richtung</strong>. Die Übung
              kann auch weniger bewegungsintensiv ausgeführt werden, indem Sie
              an Stelle der Arme nur die Unterarme oder nur die Daumen benutzen,
              um die Richtungsangabe nachzuvollziehen.
              <br/><strong>Variationen:</strong>
              <ol style={{marginTop: "0px"}}><li style={{marginLeft: "-20px"}}>Bewegen Sie an Stelle der Arme Ihre Beine in die entsprechende Richtung.</li>
              <li style={{marginLeft: "-20px"}}>Bewegen Sie Ihre Arme jeweils in die dem Pfeil entgegengesetzte Richtung.</li></ol>
            </p>
          ) : level === 2 ? (
            <p>
              Es werden nach und nach Spielkarten gezeigt, auf denen
              unterschiedliche Informationen enthalten sind, verteilt auf fünf
              Felder. Konzentrieren Sie sich ausschließlich auf die Pfeile. Ist
              der Pfeil <strong>blau</strong> oder <strong>rot</strong>, bringen
              Sie, sobald eine Karte erscheint, möglichst schnell Ihre beiden
              Arme gestreckt in die vom Pfeil
              <strong>angezeigte Richtung</strong>. Ist der Pfeil{" "}
              <strong>gelb oder grün</strong>, bewegen Sie Ihre Arme in die vom
              Pfeil <strong>entgegengesetzte Richtung</strong>.
              <br />
              <strong>Variationen:</strong>
              <br />
              Die Übung kann auch weniger bewegungsintensiv ausgeführt werden,
              indem Sie an Stelle der Arme nur die Unterarme oder nur die Daumen
              benutzen, um die Richtungsangabe nachzuvollziehen.
            </p>
          ) : (
            <p>
              Es werden nach und nach Spielkarten gezeigt, auf denen
              unterschiedliche Informationen enthalten sind, verteilt auf fünf
              Felder. Konzentrieren Sie sich ausschließlich auf die Pfeile.
              Zeigt der Pfeil auf ein <strong>Zahlenfeld</strong>, so bringen
              Sie möglichst schnell Ihre beiden Arme in die vom Pfeil{" "}
              <strong>angezeigte Richtung</strong>. Deutet der Pfeil auf ein{" "}
              <strong>Buchstabenfeld</strong>, bewegen sich Ihre Arme in die dem
              Pfeil <strong>entgegengesetzte Richtung</strong>.<br />
              Enthält das vom Pfeil angezeigte Feld ein <strong>
                Symbol
              </strong>{" "}
              oder einen <strong>geviertelten Kreis</strong>, so setzen Sie
              zusätzlich Ihre Sprache ein. Sie sprechen die Pfeilrichtung
              ("oben", "unten", etc). Ihre Arme bewegen sich dabei gleichzeitig
              in die dem Pfeil <strong>entgegengesetzte Richtung.</strong>
            </p>
          )
        ) : game?.name === "onposition" ? (
          level === 1 ? (
            <p>
              Es wird jeweils für einige Sekunden eine Spielkarte eingeblendet,
              die in fünf Felder aufgeteilt ist. Die Felder enthalten
              Informationen - Zahlen, Buchstaben, Silben, Symbole und
              Farbkreise, alle in verschiedenen Farben.
              <br />
              Schauen Sie sich die Karte genau an und merken Sie sich möglichst
              die Position der einzelnen Informationen.
              <br />
              Sobald die vollständige Karte verschwindet, sehen Sie eine leere
              Karte mit Feldeinteilung und die einzelnen Elemente, durcheinander
              angeordnet. Ziehen Sie mit der Maus die Elemente an ihre richtigen
              Positionen.
              <br />
              Klicken Sie auf <strong>Neue Spielkarte</strong> für das nächste
              Spiel.
            </p>
          ) : (
            <p>
              Es wird jeweils für einige Sekunden eine Spielkarte eingeblendet,
              die in fünf Felder aufgeteilt ist. Die Felder enthalten
              Informationen - Zahlen, Buchstaben, Silben, Symbole und
              Farbkreise, alle in verschiedenen Farben. Schauen Sie sich die
              Karte genau an und merken Sie sich möglichst die Position der
              einzelnen Informationen. Sobald die vollständige Karte
              verschwindet, sehen Sie eine leere Karte mit Feldeinteilung und
              die einzelnen Elemente, durcheinander angeordnet. <br />{" "}
              <strong>Achtung!</strong> Es sind mehr Elemente im Umlauf als auf
              der Karte abgebildet waren. Ziehen Sie mit der Maus die Elemente
              an ihre richtigen Positionen. <br />
              Klicken Sie auf <strong>Neue Spielkarte</strong> für das nächste
              Spiel.
            </p>
          )
        ) : (
          <p>next</p>
        )}
      </Content>
    </>
  );
};
